import { render, staticRenderFns } from "./RightFooterAppointment.vue?vue&type=template&id=71839ab4&scoped=true"
import script from "./RightFooterAppointment.vue?vue&type=script&lang=js"
export * from "./RightFooterAppointment.vue?vue&type=script&lang=js"
import style0 from "./RightFooterAppointment.vue?vue&type=style&index=0&id=71839ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71839ab4",
  null
  
)

export default component.exports